import { BankType, BrandType } from '../generated/graphql';
import { noPaymentReasonClaro } from './getNoPaymentReasonClaro';
import { noPaymentReasonLulo } from './getNoPaymentReasonLulo';

type NoPaymentReasonOption = { label: string, value: string };
type NoPaymentReasonOptionsFactory = () => NoPaymentReasonOption[];

const noPaymentReasonOptionsByBank: Partial<Record<BankType, NoPaymentReasonOptionsFactory>> = {
  [BankType.Claro]: noPaymentReasonClaro,
  [BankType.LuloBank]: noPaymentReasonLulo,
};

export const hasNoPaymentReasonOptions = (
  bank: BankType,
  brand?: BrandType | null,
) => (
  brand === BrandType.Tranquiapp && !!noPaymentReasonOptionsByBank[bank]
);

export const getNoPaymentReasonOptions = (
  bank: BankType,
  brand?: BrandType | null,
) => {
  if (brand !== BrandType.Tranquiapp) {
    throw new Error('No-payment reason options are only available for Tranquiapp');
  }

  const getOptions = noPaymentReasonOptionsByBank[bank];

  if (!getOptions) {
    throw new Error(`No no-payment reason options configured for bank "${bank}"`);
  }

  return getOptions();
};
